import { AuthGuard } from './auth.guard';
import { DashboardComponent } from './components/dashboard/dashboard.component';
import { DoctorComponent } from './components/doctor/doctor.component';
import { DoctorsComponent } from './components/doctors/doctors.component';
import { HospitalComponent } from './components/hospital/hospital.component';
import { HospitalsComponent } from './components/hospitals/hospitals.component';
import { InvoicesComponent } from './components/invoices/invoices.component';
import { LoginComponent } from './components/login/login.component';
import { PaymentsComponent } from './components/payments/payments.component';
import { RegisterComponent } from './components/register/register.component';
import { ReportsComponent } from './components/reports/reports.component';
import { UsersComponent } from './components/users/users.component';
import { RouterModule, Routes } from '@angular/router';

export const appRoutes: Routes = [
  {path: 'login', component: LoginComponent},
  {path: 'register', component: RegisterComponent},
  {path: 'dashboard', component: DashboardComponent, canActivate: [AuthGuard]},
  {path: 'users', component: UsersComponent, canActivate: [AuthGuard]},
  {path: 'doctors', component: DoctorsComponent, canActivate: [AuthGuard]},
  {path: 'doctor/:id', component: DoctorComponent, canActivate: [AuthGuard]},
  {path: 'hospitals', component: HospitalsComponent, canActivate: [AuthGuard]},
  {path: 'hospital/:id', component: HospitalComponent, canActivate: [AuthGuard]},
  {path: 'reports', component: ReportsComponent, canActivate: [AuthGuard]},
  {path: 'invoices', component: InvoicesComponent, canActivate: [AuthGuard]},
  {path: 'payments', component: PaymentsComponent, canActivate: [AuthGuard]},
  {path: '', redirectTo:'/dashboard', pathMatch: 'full' }
];

export const appRoutingProviders: any[] = [];

export const routing = RouterModule.forRoot(appRoutes);


// WEBPACK FOOTER //
// ./src/app/app.routes.ts